import { STATUS_CANCELED } from "../constants";
import { isBaseScheduleAdded } from "../taedUtils";

export function getSortedTempAssignmentsByLastUpdatedDate(_TempCreatedAt1, _TempCreatedAt2, Temp_1, Temp_2) {
  if (!Temp_1) {
    _TempCreatedAt1 = _TempCreatedAt1.lastUpdatedDate;
    _TempCreatedAt2 = _TempCreatedAt2.lastUpdatedDate;
  }
  if (
    _TempCreatedAt1.year === _TempCreatedAt2.year &&
    _TempCreatedAt1.month === _TempCreatedAt2.month &&
    _TempCreatedAt1.day === _TempCreatedAt2.day &&
    _TempCreatedAt1.hour === _TempCreatedAt2.hour &&
    _TempCreatedAt1.minute === _TempCreatedAt2.minute
  ) {
    return 0;
  }
  return _TempCreatedAt1.toMillis() < _TempCreatedAt2.toMillis() ? -1 : 1;
}

export function getSortedTempAssignmentsByStatus(_TempCreatedAt1, _TempCreatedAt2, Temp_1, Temp_2) {
  let timeOffRequest1Row = Temp_1.api.getRow(Temp_1.id);
  let timeOffRequest2Row = Temp_2.api.getRow(Temp_2.id);

  if (timeOffRequest1Row.statusSortOrder === timeOffRequest2Row.statusSortOrder) {
    return 0;
  }

  return timeOffRequest1Row.statusSortOrder > timeOffRequest2Row.statusSortOrder ? 1 : -1;
}

export function getSortedTempAssignmentsByBaseScheduleAdded(_TempCreatedAt1, _TempCreatedAt2, Temp_1, Temp_2) {
  let timeOffRequest1Row = Temp_1.api.getRow(Temp_1.id);
  let timeOffRequest2Row = Temp_2.api.getRow(Temp_2.id);

  const tempOneSortValue =
    timeOffRequest1Row.status === STATUS_CANCELED ? 1 : isBaseScheduleAdded(timeOffRequest1Row.baseSchedule) ? 0 : -1;
  const tempTwoSortValue =
    timeOffRequest2Row.status === STATUS_CANCELED ? 1 : isBaseScheduleAdded(timeOffRequest2Row.baseSchedule) ? 0 : -1;
  return tempOneSortValue - tempTwoSortValue;
}

export function getTempEmployeeLastNameCustomComparator(_TempCreatedAt1, _TempCreatedAt2, Temp_1, Temp_2) {
  let temp1Row = Temp_1.api.getRow(Temp_1.id);
  let temp2Row = Temp_2.api.getRow(Temp_2.id);

  if (temp1Row.empLastName === temp2Row.empLastName) {
    if (temp1Row.empFirstName === temp2Row.empFirstName) {
      return 0;
    }
    return temp1Row.empFirstName > temp2Row.empFirstName ? 1 : -1;
  }
  return temp1Row.empLastName > temp2Row.empLastName ? 1 : -1;
}
